var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { UpdateAttribute } from "Server/Commands/UpdateAttribute";
import { GetErrorMessagesUnderElement, Clone } from "js-vextensions";
import { Button, Row, TextInput } from "react-vcomponents";
import { ApplyBasicStyles, BaseComponent } from "react-vextensions";
import { ShowMessageBox } from "react-vmessagebox";
import { GetUpdates } from "vwebapp-framework";
import { DeleteAttribute } from "../../Server/Commands/DeleteAttribute";
export class AttributeDetailsUI extends BaseComponent {
    ComponentWillMountOrReceiveProps(props, forMount) {
        if (forMount || props.baseData != this.props.baseData) { // if base-data changed
            this.SetState({ newData: Clone(props.baseData) });
        }
    }
    render() {
        const { forNew, enabled, style, onChange } = this.props;
        const { newData } = this.state;
        const Change = _ => {
            if (onChange)
                onChange(this.GetNewData(), this);
            this.Update();
        };
        const splitAt = 170;
        const width = 600;
        return (React.createElement("div", null,
            " ",
            React.createElement(Row, null,
                !enabled && React.createElement(Row, null, newData.name),
                enabled && React.createElement(TextInput, { style: { width: 100 }, value: newData.name, onChange: val => Change(newData.name = val) }))));
    }
    GetValidationError() {
        return GetErrorMessagesUnderElement(this.DOM)[0];
    }
    GetNewData() {
        const { newData } = this.state;
        return Clone(newData);
    }
}
let AttributeEditorUI = class AttributeEditorUI extends BaseComponent {
    render() {
        const { attribute } = this.props;
        const { editing } = this.state;
        return (React.createElement(Row, { style: { flexShrink: 0 } },
            React.createElement(AttributeDetailsUI, { ref: c => this.detailsUI = c, baseData: attribute, enabled: editing }),
            !editing &&
                React.createElement(Button, { ml: 5, text: "Edit", onClick: () => this.SetState({ editing: true }) }),
            editing &&
                React.createElement(Button, { ml: 5, text: "Save", onClick: async () => {
                        const updates = GetUpdates(attribute, this.detailsUI.GetNewData());
                        await new UpdateAttribute({ id: attribute._key, updates }).Run();
                        this.SetState({ editing: false });
                    } }),
            editing &&
                React.createElement(Button, { ml: 5, text: "Cancel", onClick: () => this.SetState({ editing: false }) }),
            React.createElement(Button, { ml: 5, text: "X", onClick: () => {
                    ShowMessageBox({
                        title: "Delete attribute?",
                        message: "This will delete all usages of the attribute for characters and seeds.",
                        cancelButton: true,
                        onOK: async () => {
                            new DeleteAttribute({ id: attribute._key }).Run();
                        },
                    });
                } })));
    }
};
AttributeEditorUI = __decorate([
    ApplyBasicStyles
], AttributeEditorUI);
export { AttributeEditorUI };
